import {useEffect, useRef, useState} from "react";
import AppService from "./services/AppService";
import Main from "./views/Main";
import ApiService from "./services/ApiService";
import {setData} from "./redux/data";
import {useSelector, useDispatch} from 'react-redux'

import {useClearCacheCtx} from 'react-clear-cache';
import {Button, ConfigProvider, Dropdown, Modal} from "antd";
import EmergencyCall from "./components/EmergencyCall"
import {ENV} from "./configs/AppConfig";
import {getShabbatYomTovRanges} from "./hebcal";


let intervalTime = 2 * 60 * 1000

if (ENV === "DEV") {
    intervalTime = 10 * 1000
}

function App() {
    const [isShabbat, setIsShabbat] = useState(localStorage.getItem("SHABBAT") === "1" || false)
    const [autoShabbat, setAutoShabbat] = useState(false)

    //RELOAD UPDATE
    const {isLatestVersion, emptyCacheStorage} = useClearCacheCtx();
    if (!isLatestVersion) {
        try { emptyCacheStorage() } catch (e) { console.error("emptyCacheStorage failed", e); }
    }

    const [inited, setInited] = useState(false)
    const [initError, setInitError] = useState(null)
    const [attempts, setAttempts] = useState(0)
    const dispatch = useDispatch()

    const checkAutoShabbat = (borne, org) => {
        try {
            if (borne && org) {
                let isAutoShabbat = false
                if (borne.autoShabbat) {
                    isAutoShabbat = calculIsShabbat(org)
                }
                setAutoShabbat(isAutoShabbat)
            }
        } catch (e) {
            console.error("checkAutoShabbat failed", e);
        }
    }


    const getData = async () => {
        const borneId = window.BORNEID

        try {
            const res = await ApiService.get("/id/" + borneId)
            if (res && res.success) {
                dispatch(setData({borne: res.data, organisation: res.organisation}))
                setInited(true)
                setInitError(null)
                checkAutoShabbat(res.data, res.organisation)
                return true
            } else {
                console.error("getData unsuccessful", res);
                if (!inited) setInitError(res?.error || "Réponse serveur invalide");
                return false
            }
        } catch (e) {
            console.error("getData failed", e);
            if (!inited) setInitError(e?.message || String(e));
            return false
        }
    }

    useEffect(() => {
        if (!window.ISWEB) {
            try {
                AppService.init()

                AppService.addEventListener("shabbat.state", (_data) => {
                    try {
                        const bool = _data.data
                        localStorage.setItem("SHABBAT", bool ? "1" : "0")
                        setIsShabbat(bool)
                    } catch (e) { console.error("shabbat.state handler failed", e); }
                })
            } catch (e) {
                console.error("AppService.init failed", e);
            }
        }

        let cancelled = false;
        const initialFetch = async () => {
            for (let i = 1; i <= 10 && !cancelled; i++) {
                setAttempts(i);
                const ok = await getData();
                if (ok) return;
                await new Promise(r => setTimeout(r, Math.min(2000 * i, 10000)));
            }
        };
        initialFetch();

        const interval = setInterval(() => getData(), intervalTime)
        return () => {
            cancelled = true;
            clearInterval(interval)
        }
    }, []);


    if (!inited) {
        if (initError) {
            return (
                <div style={errorStyles.wrap}>
                    <div style={errorStyles.title}>Connexion serveur impossible</div>
                    <div style={errorStyles.msg}>{String(initError)}</div>
                    <div style={errorStyles.attempts}>Tentatives: {attempts}</div>
                    <button
                        style={errorStyles.button}
                        onClick={() => {
                            setInitError(null);
                            setAttempts(0);
                            getData();
                        }}
                    >
                        Réessayer
                    </button>
                </div>
            );
        }

        return (
            <span style={{color: "#FFF", marginTop: 100, marginLeft: 30}}>
                Initialisation de la borne - {window.BORNEID}{attempts > 1 ? ` (tentative ${attempts})` : ""}
            </span>
        )
    }

    if (isShabbat || autoShabbat) {
        return <ShabbatMode/>
    }

    return (
        <Main refreshData={() => getData()}/>
    );
}

export default App;


function ShabbatMode() {

    const borne = useSelector(state => state.data.borne)

    let screenId = borne?.shabbatScreen || 2

    let emergencyType = borne?.emergencyType || "SHABBAT"

    return (
        <ConfigProvider
            theme={{
                components: {
                    Dropdown: {
                        paddingBlock: 0
                    },
                },
            }}
        >
            <div style={{
                position: "relative",
                height: "100vh",
                width: "100vw",
                backgroundColor: "#000",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }}>
                <video src={"/assets/video/chabbat/" + screenId + ".mp4"} muted autoPlay loop
                       style={{position: "absolute", top: 0, left: 0, height: "100%", width: "100%"}}/>

                {emergencyType !== "NONE" && (
                    <div style={{
                        position: "absolute",
                        top: "40vh",
                        width: "100vw",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}>
                        <div style={{width: "80vw"}}>
                            <EmergencyCall/>
                        </div>
                    </div>
                )}

            </div>

        </ConfigProvider>
    )
}



function calculIsShabbat(org) {
    try {
        const lat = parseFloat(org.lat)
        const lon = parseFloat(org.long)
        const il = org.country === "IL"

        let now = new Date();

        if (ENV === "DEV") {
            //now.setHours(22,0,0,0)
            //now.setMonth(7,1)
        }

        const shabbatRange = getShabbatYomTovRanges(now, lat, lon, il)
        const isShabbat = shabbatRange.some(range => now.getTime() >= range.start.getTime() && now.getTime() < range.end.getTime());
        return isShabbat
    } catch (e) {
        console.error("calculIsShabbat failed", e);
        return false;
    }
}


const errorStyles = {
    wrap: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
        backgroundColor: "#1a1a1a",
        color: "#fff",
        fontFamily: "system-ui, sans-serif",
        padding: 20,
        textAlign: "center",
    },
    title: { fontSize: 22, color: "#ff7875", fontWeight: "bold", marginBottom: 10 },
    msg: { color: "#ddd", marginBottom: 6, maxWidth: 600 },
    attempts: { color: "#888", fontSize: 12, marginBottom: 20 },
    button: {
        backgroundColor: "#2196f3",
        color: "#fff",
        padding: "12px 24px",
        border: "none",
        borderRadius: 8,
        fontWeight: "bold",
        cursor: "pointer",
    },
};
